<template>
  <div class="input-field">
    <div class="label">{{label}}</div>
    <div class=input-warp>
      <input
        v-if="disabled"
        :type="inputType"
        :placeholder="hint"
        v-model="value"
        disabled/>
      <input
        v-if="!disabled"
        :type="inputType"
        :placeholder="hint"
        v-model="value"/>
      <img
        v-if="type==='password'"
        class="swiitch"
        @click="swiitchVisibility"
        :src="switchSrc"/>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import showPasswordImage from '@/assets/password-show.svg'
import hidePasswordImage from '@/assets/password-hide.svg'

export default defineComponent({
  name: 'Toolbar',
  props: {
    label: String,
    hint: String,
    type: {
      type: String,
      default: 'text'
    },
    defaultValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputType () {
      if (this.type === 'password' && !this.showPassword) {
        return 'password'
      } else {
        return 'text'
      }
    },
    switchSrc () {
      if (!this.showPassword) {
        return showPasswordImage
      } else {
        return hidePasswordImage
      }
    }
  },
  data: function () {
    return {
      showPassword: false,
      value: this.defaultValue
    }
  },
  methods: {
    swiitchVisibility () {
      this.showPassword = !this.showPassword
    }
  },
  watch: {
    value: function () {
      this.$emit('value', this.value)
    },
    defaultValue: function () {
      this.value = this.defaultValue
    }
  }
})
</script>

<style lang="scss">
  .input-field {
    width: 100%;
    .label {
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      margin-bottom: 4px;
    }
    .input-warp {
      position: relative;
      display: flex;
      width: 100%;
      height: 48px;
      border: 0px;
      border-radius: 6px;
      background-color: white;
    }
    input {
      flex-grow: 1;
      font-size: 16px;
      color: #93987c;
      border: 0px;
      background-color: transparent;
      padding-left: 26px;
    }
    ::placeholder {
      color: #93987c;
      font-size: 16px;
      font-weight: 500;
    }
    .swiitch {
      position: absolute;
      right: 14px;
      height: 48px;
      width: 48px;
      object-position: center;
      object-fit: none;
      cursor: pointer;
    }
  }
</style>
